import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload } from "shared-utility/store/utils/helpers";

// ACTIONS
export const NOI_WIZARD_STEP_INCREMENT = generateDefaultActions("NOI_WIZARD_STEP_INCREMENT");
export const wizardStepIncrement = () => makePayload(NOI_WIZARD_STEP_INCREMENT.value);

export const NOI_WIZARD_STEP_DECREMENT = generateDefaultActions("NOI_WIZARD_STEP_DECREMENT");
export const wizardStepDecrement = () => makePayload(NOI_WIZARD_STEP_DECREMENT.value);

export const SET_NOI_SELECTIONS = generateDefaultActions("SET_NOI_SELECTIONS");
export const setNoiSelections = payload => makeWritePayload(SET_NOI_SELECTIONS.value, payload);

export const SET_NOI_SETUP_LOADING = generateDefaultActions("SET_NOI_SETUP_LOADING");
export const setNoiSetupLoading = () => makeWritePayload(SET_NOI_SETUP_LOADING.value);

export const actionCreators = {
  setNoiSelections,
  setNoiSetupLoading,
  wizardStepDecrement,
  wizardStepIncrement
};

// REDUCER

const initialState = {
  isLoading: false,
  shouldTrackByPortfolio: false,
  shouldTrackIndividualProperty: false,
  uploadErrorMessage: undefined,
  wizardStep: 1
};

export function lenderReportsNoiSetupReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_NOI_SETUP_LOADING.value:
      return defaultReturn({ ...state, isLoading: Boolean(payload) });
    case SET_NOI_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });
    case NOI_WIZARD_STEP_INCREMENT.value:
      return defaultReturn({ ...state, wizardStep: state.wizardStep + 1 });
    case NOI_WIZARD_STEP_DECREMENT.value:
      return defaultReturn({ ...state, wizardStep: state.wizardStep - 1 });

    default:
      return state;
  }
}
